import { cartHook, converPriceStrToNum, customerInfo } from "./Utils";

// Fallback URL for when REACT_APP_LOCAL_IP is not set
const FALLBACK_URL = "http://localhost:8000";
console.log("REACT_APP_LOCAL_IP value:", process.env.REACT_APP_LOCAL_IP);
/**
 * Fetches pasterys from the API
 * @returns {Promise} List of all pasterys
 */
export const fetchPasterys = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(`${apiUrl}/inventorymanager/pastries/`);
  return response.json();
};

/**
 * Fetches news topics from the API
 * @returns {Promise} List of all topics
 */
export const fetchNews = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(
    `${apiUrl}/eventmanager/events/`
  );
  return response.json();
};

/**
 * Fetches employee info from the API
 * @returns {Promise} the first employee in the database
 */
export const fetchInfo = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(
    `${apiUrl}/eventmanager/employee/`
  );
  return response.json();
};

/**
 * Fetches favourites pasterys from the API
 * @returns {Promise} List of all favourites pasterys
 */
export const fetchFavouritesPasterys = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(
    `${apiUrl}/inventorymanager/favourites/`
  );

  return response.json();
};

/**
 * Fetches comapny info from the API
 * @returns {Promise} object with company info
 */
export const fetchCompanyInfo = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(
    `${apiUrl}/eventmanager/company/`
  );
  return response.json();
};

/**
 * Fetches crsf token
 * @returns {Promise} object with company info
 */
export const fetchDisabledDates = async () => {
  const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
  const response = await fetch(
    `${apiUrl}/ordermanager/`,
    { credentials: "include" }
  );
  return response.json();
};

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

/**
 * Posts order info to the API
 * @returns {Promise} object with company info
 */
export const createOrder = async (order) => {
  try {
    // Debug log for environment variable
    console.log("REACT_APP_LOCAL_IP value:", process.env.REACT_APP_LOCAL_IP);
    const csrfToken = getCookie("csrftoken");
    console.log("CSRF Token:", csrfToken)
    const apiUrl = process.env.REACT_APP_LOCAL_IP || FALLBACK_URL;
    const response = await fetch(`${apiUrl}/ordermanager/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify(order),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (e) {
    console.error("Order creation failed:", e);
    throw new Error(
      "Tilaus epäonnistui. Avaa sivusto uudelleen ja kokeile uusiksi. Mikäli ongelma jatkuu olethan yhteydessä minuun puhelimitse tai sähköpostitse."
    );
  }
};

export const getCartItems = () => {
  return cartHook;
};

export const getCustomerInfo = () => customerInfo;
